module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-box",
    class: _vm.colourClass
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.menuVisible = !_vm.menuVisible
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n        "), _c('v-menu', {
    staticClass: "button",
    attrs: {
      "value": _vm.menuVisible,
      "left": "",
      "nudge-bottom": 7,
      "nudge-right": 9,
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "small": "",
            "icon": ""
          }
        }, on), [_c('v-icon', {
          staticClass: "button"
        }, [_vm._v("keyboard_arrow_down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.optionsList), function(item, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.selectItem(item)
        }
      }
    }, [_c('v-list-item-action', [_c('v-icon', {
      class: _vm.textColourClass(item.colour)
    }, [_vm._v("label")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.label))])], 1)], 1)
  }), 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2982c9ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/StatusBox.vue
// module id = 2488
// module chunks = 1